/**
 * Fold diacritics and Sanskrit transliteration for Sacred Library search.
 * "Ekadashi" / "ekadasi" / "Ekādaśī" → comparable tokens.
 */
export function normalizeSearchText(text) {
  let s = String(text ?? "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "");

  const map = [
    [/ā|à|á|ä/g, "a"],
    [/ī|ì|í|ï/g, "i"],
    [/ū|ù|ú|ü/g, "u"],
    [/ē|è|é/g, "e"],
    [/ō|ò|ó/g, "o"],
    [/ś|ṣ|š|ç/g, "sh"],
    [/ṭ/g, "t"],
    [/ḍ/g, "d"],
    [/ṇ/g, "n"],
    [/ṃ|ṁ/g, "m"],
    [/ḥ/g, "h"],
    [/ṛ/g, "r"],
    [/ñ/g, "n"],
  ];
  for (const [re, rep] of map) s = s.replace(re, rep);

  return s.replace(/[^a-z0-9\s]/g, " ").replace(/\s+/g, " ").trim();
}

/** Extra tokens indexed per library id (ASCII-friendly). */
export const SEARCH_ALIASES = {
  ekadashi: ["ekadashi", "ekadasi", "ekadasi vrata", "ekadasi upavas", "vaikuntha ekadashi"],
  pradosham: ["pradosham", "pradosha", "pradosh"],
  sankashti: ["sankashti", "sankastahara", "sankatahara chaturthi"],
  purnima: ["purnima", "poornima", "full moon"],
  amavasya: ["amavasya", "amavasai", "new moon"],
  monthly_shivaratri: ["shivaratri", "sivarathri", "masa shivaratri"],
  maha_shivaratri: ["maha shivaratri", "mahashivaratri"],
  rama_navami: ["rama navami", "ram navami"],
  krishna_janmashtami: ["janmashtami", "krishna janmashtami", "gokulashtami"],
  nrisimha_jayanti: ["narasimha", "nrisimha", "nrusimha"],
  ganesh_chaturthi: ["ganesh chaturthi", "vinayaka chaturthi", "ganapati"],
  shiva: ["shiva", "siva", "mahadev"],
  vishnu: ["vishnu", "narayana", "hari"],
  krishna: ["krishna", "krsna", "govinda"],
  rama: ["rama", "ram", "sitaram"],
  ganesha: ["ganesha", "ganapati", "vinayaka"],
  hanuman: ["hanuman", "anjaneya", "maruti"],
  durga: ["durga", "devi", "ambika"],
  parvati: ["parvati", "parvathi", "uma"],
  lakshmi: ["lakshmi", "mahalakshmi"],
  saraswati: ["saraswati", "sarasvati"],
};

export function searchBlobForEntry(type, entry) {
  const name = entry.name || entry.title || "";
  const summary = entry.beginner?.identity || entry.beginner?.meaning || entry.beginner?.summary || entry.beginner?.purpose || "";
  const parts = [name, entry.id, summary, type, ...(SEARCH_ALIASES[entry.id] || [])];
  return normalizeSearchText(parts.join(" "));
}
